import React, { memo, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import MapPolygon from '../../MapObjects/MapPolygon';
import MapFieldHole from '../../MapObjects/MapFieldHole';
import { Coordinate, CoordinateObject, Ring, PolygonCoordinates } from '../../../../types/geo';

const mapStoreToProps = (store: any) => ({
  selectedField: store.field.selectedField,
});

type PropsFromRedux = ConnectedProps<typeof connector>;

const EditFieldBoundaries: React.FC<PropsFromRedux> = ({ selectedField }) => {
  const [coordinates] = useState(
    selectedField.polygon.coordinates.map((ring: Ring): CoordinateObject[] => {
      return ring.map((coord: Coordinate): CoordinateObject => {
        return {
          lng: coord[0],
          lat: coord[1],
        };
      });
    })
  );

  const visibleFieldHoles: PolygonCoordinates = selectedField.polygon.coordinates.slice(1);

  return (
    <>
      <MapPolygon
        fillOpacity={0.0}
        fillColor={'white'}
        strokeColor={'rgb(224,210,61)'}
        strokeWeight={2}
        disabled={true}
        coordinates={coordinates[0]}
        selected={false}
        zIndex={0}
      />
      {visibleFieldHoles &&
        visibleFieldHoles.map((boundary, index) => (
          <MapFieldHole fieldHole={boundary} key={index} fieldHoleDisabled={true} />
        ))}
    </>
  );
};

const connector = connect(mapStoreToProps);
export default memo(connector(EditFieldBoundaries));
